"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ViewBar;

var _List2 = _interopRequireDefault(require("@material-ui/core/List"));

var _Skeleton2 = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _ListItem2 = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Typography2 = _interopRequireDefault(require("@material-ui/core/Typography"));

var _CallMadeRounded2 = _interopRequireDefault(require("@material-ui/icons/CallMadeRounded"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("../components/Button"));

var _styles = _interopRequireDefault(require("./styles"));

var _useGetMoreViews3 = _interopRequireDefault(require("./useGetMoreViews"));

var _ViewAddMenu = _interopRequireDefault(require("./ViewAddMenu"));

var _ViewItem = _interopRequireDefault(require("./ViewItem"));

var _ViewMore = _interopRequireDefault(require("./ViewMore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

ViewBar.propTypes = {
  color: _propTypes["default"].string,
  views: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string,
    type: _propTypes["default"].string,
    name: _propTypes["default"].string
  })),
  selectedView: _propTypes["default"].objectOf({
    id: _propTypes["default"].string,
    type: _propTypes["default"].string,
    name: _propTypes["default"].string
  }),
  name: _propTypes["default"].string,
  onClickName: _propTypes["default"].func,
  isLoading: _propTypes["default"].bool,
  onDuplicate: _propTypes["default"].func,
  onDelete: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func,
  onSelect: _propTypes["default"].func,
  onCreate: _propTypes["default"].func
};
ViewBar.defaultProps = {
  color: "blue"
};

function ViewBar(_ref) {
  var color = _ref.color,
      views = _ref.views,
      selectedView = _ref.selectedView,
      name = _ref.name,
      onClickName = _ref.onClickName,
      isLoading = _ref.isLoading,
      onDuplicate = _ref.onDuplicate,
      onDelete = _ref.onDelete,
      onUpdate = _ref.onUpdate,
      onSelect = _ref.onSelect,
      onCreate = _ref.onCreate;
  var classes = (0, _styles["default"])();

  var _useGetMoreViews = (0, _useGetMoreViews3["default"])({
    views: views,
    selectedView: selectedView
  }),
      _useGetMoreViews2 = _slicedToArray(_useGetMoreViews, 2),
      showViews = _useGetMoreViews2[0],
      moreViews = _useGetMoreViews2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/_react["default"].createElement(_List2["default"], {
    dense: true,
    className: classes.flexContainer
  }, name && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onClickName,
    size: "small",
    startIcon: /*#__PURE__*/_react["default"].createElement(_CallMadeRounded2["default"], {
      fontSize: "small"
    })
  }, /*#__PURE__*/_react["default"].createElement(_Typography2["default"], {
    className: classes.tableName,
    variant: "subtitle1"
  }, name))), /*#__PURE__*/_react["default"].createElement(_ListItem2["default"], {
    style: {
      alignItems: "center",
      width: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divider
  }))), isLoading && /*#__PURE__*/_react["default"].createElement(_Skeleton2["default"], {
    variant: "rect",
    style: {
      borderRadius: 4
    },
    height: 28,
    width: 100
  }), showViews === null || showViews === void 0 ? void 0 : showViews.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_ViewItem["default"], _extends({}, item, {
      key: item === null || item === void 0 ? void 0 : item.id,
      color: color,
      total: views === null || views === void 0 ? void 0 : views.length,
      onUpdate: onUpdate,
      onDelete: onDelete,
      onDuplicate: onDuplicate,
      onSelect: onSelect,
      selectedView: selectedView
    }));
  })), !!moreViews.length && /*#__PURE__*/_react["default"].createElement(_ViewMore["default"], {
    moreViews: moreViews,
    onSelect: onSelect
  }), /*#__PURE__*/_react["default"].createElement(_ListItem2["default"], {
    style: {
      alignItems: "center",
      width: "auto"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.divider
  })), isLoading ? /*#__PURE__*/_react["default"].createElement(_Skeleton2["default"], {
    variant: "rect",
    style: {
      borderRadius: 4
    },
    height: 28,
    width: 100
  }) : /*#__PURE__*/_react["default"].createElement(_ViewAddMenu["default"], {
    onCreate: onCreate
  }));
}